import React, { useState, useEffect } from 'react';
import { baseURL } from '../apiConfig';
import './LiveRateStrip.css';

const LiveRateStrip = ({ onRatesUpdate, onEditingChange }) => {
  const userRole = sessionStorage.getItem('userRole');
  
  const [rates, setRates] = useState({
    gold24k: 0,
    gold22k: 0,
    gold18k: 0,
    silver100: 0,
    silver925: 0,
    silverCB: 0
  });

  const [isEditingRates, setIsEditingRates] = useState(false);

  useEffect(() => {
    fetchRates();
  }, []);

  const fetchRates = async () => {
    try {
      const response = await fetch(`${baseURL}/api/live-rates/`);
      const data = await response.json();
      if (data.success) {
        const fetchedRates = {
          gold24k: parseFloat(data.rates.gold24k) || 0,
          gold22k: parseFloat(data.rates.gold22k) || 0,
          gold18k: parseFloat(data.rates.gold18k) || 0,
          silver100: parseFloat(data.rates.silver100) || 0,
          silver925: parseFloat(data.rates.silver925) || 0,
          silverCB: parseFloat(data.rates.silverCB) || 0
        };
        setRates(fetchedRates);
        if (onRatesUpdate) {
          onRatesUpdate(fetchedRates);
        }
      }
    } catch (error) {
      console.error("Error fetching live rates", error);
    }
  };

  const handleRateInputChange = (key, val) => {
    setRates(prev => ({ ...prev, [key]: parseFloat(val) || 0 }));
  };

  const toggleEditRates = async () => {
    if (isEditingRates) {
      try {
        const response = await fetch(`${baseURL}/api/live-rates/`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(rates)
        });
        const data = await response.json();
        if (data.success) {
          alert("Aaj ke Live Rates database me Save ho gaye hain! 💾");
          if (onRatesUpdate) {
            onRatesUpdate(rates);
          }
        } else {
          alert("Error saving rates: " + data.message);
        }
      } catch (error) {
        alert("Server error while saving rates!");
      }
    }
    const nextEditing = !isEditingRates;
    setIsEditingRates(nextEditing);
    if (onEditingChange) {
      onEditingChange(nextEditing);
    }
  };

  return (
    <div className="rate-bar-container">
      <div className="rate-bar-title">🔥 TODAY'S LIVE RATES (₹/g)</div>
      
      <div className="rate-bar-items">
        {/* Gold Rates */}
        <div className="rate-item">
          <label>Gold 24K</label>
          <input 
            type="number" 
            disabled={!isEditingRates} 
            value={rates.gold24k || ''} 
            onChange={(e) => handleRateInputChange('gold24k', e.target.value)} 
            placeholder="0"
          />
        </div>
        <div className="rate-item">
          <label>Gold 22K</label>
          <input 
            type="number" 
            disabled={!isEditingRates} 
            value={rates.gold22k || ''} 
            onChange={(e) => handleRateInputChange('gold22k', e.target.value)} 
            placeholder="0"
          />
        </div>
        <div className="rate-item">
          <label>Gold 18K</label>
          <input 
            type="number" 
            disabled={!isEditingRates} 
            value={rates.gold18k || ''} 
            onChange={(e) => handleRateInputChange('gold18k', e.target.value)} 
            placeholder="0"
          />
        </div>

        {/* Silver Rates */}
        <div className="rate-item">
          <label>Silver 100%</label>
          <input 
            type="number" 
            disabled={!isEditingRates} 
            value={rates.silver100 || ''} 
            onChange={(e) => handleRateInputChange('silver100', e.target.value)} 
            placeholder="0"
          />
        </div>
        <div className="rate-item">
          <label>Silver 92.5</label>
          <input 
            type="number" 
            disabled={!isEditingRates} 
            value={rates.silver925 || ''} 
            onChange={(e) => handleRateInputChange('silver925', e.target.value)} 
            placeholder="0"
          />
        </div>
        <div className="rate-item">
          <label>Silver CB</label>
          <input 
            type="number" 
            disabled={!isEditingRates} 
            value={rates.silverCB || ''} 
            onChange={(e) => handleRateInputChange('silverCB', e.target.value)} 
            placeholder="0"
          />
        </div>

        {/* Edit Button sirf tab dikhega jab user Guest nahi hoga */}
        {userRole !== 'Guest' && (
            <button type="button" className="btn-rate-edit" onClick={toggleEditRates}>
            {isEditingRates ? '💾 Save Rates' : '✏️ Edit Rates'}
            </button>
        )}
      </div>
    </div>
  );
};

export default LiveRateStrip;
